import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-admin-electable-committees',
  templateUrl: './admin-electable-committees.component.html',
  styleUrls: ['./admin-electable-committees.component.css']
})
export class AdminElectableCommitteesComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  electablecommittees: any[] = [];
  cols: any[];
  formdata;
  display = false;
  committees: SelectItem[] = [];
  institutions: SelectItem[] = [];
  institutiontypes: SelectItem[] = [];
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    private institutionService: InstitutionsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'committeeAbbreviation', header: 'Förkortning' },
      { field: 'committeeName', header: 'Namn' },
      { field: 'institutionTypeIdName', header: 'Institutionstyp' },
      { field: 'institutionShortName', header: 'Institution' }
    ];
    this.getElectableCommittees();
  }

  getElectableCommittees() {
    this.adminService.GetElectableCommittees().subscribe(data => {
      if (data) {
        this.electablecommittees = data;
        this.getInstitutionTypes();
      }
    });
  }

  getInstitutionTypes() {
    this.institutionService.getInstitutionTypes().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.institutiontypes.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.institutiontypes.unshift(emptyrecord);
      }
    });
  }

  add() {
    this.addElectableCommittee();
  }

  addElectableCommittee() {
    this.adminService.GetCommittees().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.name + ' [' + d.abbreviation + ']', value: d.id
          };
          this.committees.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.committees.unshift(emptyrecord);
        this.getInstitutions();
      }
    });
  }

  getInstitutions() {
    this.institutionService.getInstitutions().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.shortName + ' - ' + d.name, value: d.id
          };
          this.institutions.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.institutions.unshift(emptyrecord);
        this.display = true;
      }
    });
  }

  saveElectableCommittees(evt) {
    this.adminService.AddElectableCommittee(evt).subscribe(data => {
      if (data) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Electable Committee tillagt.' });
        this.getElectableCommittees();
      }
    });
    this.display = false;
  }

  cancelAdd() {
    this.display = false;
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera vald electable committee?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.deleteElectableCommittee(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteElectableCommittee(rowdata) {
    this.adminService.RemoveElectableCommittee(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Electable committee raderad.' });
        this.getInstitutionTypes();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {

    // tslint:disable-next-line:max-line-length
    let firstrow = 'Utskott Förkortning;Utskott Namn;Institutionstyp;Institution';
    const filnamn = 'OF_electablecommittees';
    const excelrecords: any[] = [];
    this.electablecommittees.forEach(r => {
      const row = {
        committeeAbbreviation: r.committeeAbbreviation,
        committeeName: r.committeeName,
        institutionTypeIdName: r.institutionTypeIdName,
        institutionIdName: r.institutionShortName
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }
}
